<div class="subheader py-2 pb-1 pt-1" id="kt_subheader">
    <div class="d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap container-fluid">
        <div class="d-flex align-items-center flex-wrap mr-1">
            <ng-container *ngIf="subheaderMobileToggle">
                <button class="burger-icon burger-icon-left mr-4 d-inline-block d-lg-none" id="kt_subheader_mobile_toggle">
                    <span></span>
                </button>
            </ng-container>
            <div class="d-flex flex-column">
                <ng-container>
                    <h2 class="text-white font-weight-bold my-2 mr-5" style="font-size: 30px">
                        <a class="inactive-icon">
                            <img [src]="imgSrc" alt="" (mouseenter)="onMouseOver()" (mouseleave)="onMouseOut()" />
                        </a>
                        <ng-container>
                            {{ headerData?.displayText }}
                        </ng-container>
                    </h2>
                </ng-container>
            </div>
        </div>

        <div class="d-flex justify-content-end">
            <div class="activity_header_wrapper d-flex align-items-center justify-content-end w-100">
                <span class="activity_title">{{ 'PROFILE_PAGE.PERSONAL_TAB.LABELS.ORGANIZATION_NAME' | transloco }}</span>
                <span class="section-data">{{ currentOrganizationName }}</span>
                <span class="activity_title">{{ 'PROFILE_PAGE.PERSONAL_TAB.LABELS.INSTANCE_NAME' | transloco }}</span>
                <span class="section-data">{{ currentInstanceName }}</span>
                <span class="activity_title" *ngIf="currentAssetType">{{ 'PROFILE_PAGE.PERSONAL_TAB.LABELS.ASSET_TYPE' | transloco }}</span>
                <span class="section-data" *ngIf="currentAssetType">{{ currentAssetType }}</span>
            </div>

            <div class="d-flex align-items-center">
                <div
                    class="dropdown dropdown-inline ml-2"
                    data-toggle="tooltip"
                    title="Quick actions"
                    data-placement="left"
                    placement="bottom-right"
                    ngbDropdown
                >
                    <app-tagged-item-create
                        *ngIf="isAddEnabled === true && router.url == '/idms/plantmanager' && tabIndex === 0 && isAddPermission"
                        style="padding-right: 15px"
                        [ConnectorChildrenList]="ConnectorChildrenList"
                    ></app-tagged-item-create>
                    <div>
                        <a
                            href="javascript:void(0)"
                            *ngIf="router.url == '/idms/plantmanager' && tabIndex !== 0 && isAddPermission"
                            (click)="uploadDocument()"
                            class="btn primary-ebtn font-weight-bold py-3 px-6"
                        >
                            {{ 'SETTING_PAGE.IDMS_SETTINGS.ADD' | transloco }}
                        </a>
                    </div>
                    <app-add-new-projects (isProjectAdded)="isProjecAddedHandler($event)" *ngIf="shouldShowAddNewProjects()"></app-add-new-projects>
                </div>
            </div>
        </div>
    </div>
</div>
